export default __webpack_public_path__ + "static/media/home4.0ea66971.jpg";